module.exports = "assets/dcce97cf28a08522c167f77111bdab5d.glb";